import React from 'react';
import logoArgos from '../../ressources/accueil/argos ITM.png';
import classes from './Logo.module.scss';
const Logo = ({ src }) => {
  return (
    <div className={classes.LogoClasse}>
      <img
        alt="logo"
        src={src || logoArgos}
        className={[classes.imageLogo].join(' ')}
      />
    </div>
  );
};

export default Logo;
